<div style="padding-top: 1rem" class="row-not-wrap container flex-direction-xs-col col">
  <div class="col-md-3 col-lg-2 col-xs-12 register-left-side-menu">
    <mat-stepper [linear]="true" orientation="vertical" #stepper>
      <mat-step [stepControl]="ownerForm">
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
        </ng-template>
        <ng-template matStepLabel>Owner</ng-template>
      </mat-step>
      <mat-step>
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
        </ng-template>
        <ng-template matStepLabel>Rental Property</ng-template>
      </mat-step>
      <mat-step>
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
        </ng-template>
        <ng-template matStepLabel>Rental Property Reporting</ng-template>
      </mat-step>
      <mat-step>
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
        </ng-template>
        <ng-template matStepLabel>Rental Property Licenses</ng-template>
      </mat-step>
      <mat-step>
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
        </ng-template>
        <ng-template matStepLabel>Agreements</ng-template>
      </mat-step>
    </mat-stepper>
  </div>
  <div *ngIf="stepper.selectedIndex == 0" class="col-md-8 col-lg-7 col-xs-12 register-main-content">
    <form [formGroup]="ownerForm" class="row">
      <div class="row gap-32 margin-bottom flex-direction-xs-col">
        <div class="col-md-4 col-xs-12">&nbsp;</div>
        <div class="col-md-8 col-xs-12">
          <div class="row gap-32 flex-direction-xs-col">
            <mat-radio-group aria-label="Select owner's address type">
              <div class="row flex align-item-center gap-10">
                <div class="col-md-12">
                  <mat-label> Select owner's address type</mat-label>
                </div>
                <div class="col">
                  <mat-radio-button (change)="radioChangeAddress($event)" [checked]="true" color="primary"
                    value="1">Domestic</mat-radio-button>
                </div>
                <div class="col">
                  <mat-radio-button (change)="radioChangeAddress($event)" color="primary" value="2">International</mat-radio-button>
                </div>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="row gap-32">
        <div class="col-md-4 col-xs-12">
          <div class="row">
            <mat-form-field appearance="outline" requiered>
              <mat-label style="font-size: 16px !important">Owner's First name</mat-label>
              <input matInput formControlName="firstName" placeholder="Owner's First name" required />
              <mat-error>Owner's First name is required</mat-error>
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label style="font-size: 16px !important">Owner's Last name</mat-label>
              <input matInput formControlName="lastName" placeholder="Owner's Last name" />
              <mat-error>Owner's Last name is required</mat-error>
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label style="font-size: 16px !important">Owner's email address</mat-label>
              <input matInput formControlName="email" placeholder="Owner's Email" required />
              <mat-error
                *ngIf="this.ownerForm.get('email')?.errors?.['email'] && (ownerForm.get('email')?.touched)">Owner's
                email address is invalid</mat-error>

              <mat-error
                *ngIf="this.ownerForm.get('email')?.errors?.['required'] && (ownerForm.get('email')?.touched)">Owner's
                email address is required</mat-error>
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label style="font-size: 16px !important">Owner's Phone Number</mat-label>
              <input matInput appPhoneFormat formControlName="phoneNumber" placeholder="Owner's Phone Number" required />
              <mat-error
                *ngIf="this.ownerForm.get('phoneNumber')?.errors?.['pattern'] && (ownerForm.get('phoneNumber')?.touched)">Owner's
                Phone number is invalid</mat-error>

              <mat-error
                *ngIf="this.ownerForm.get('phoneNumber')?.errors?.['required'] && (ownerForm.get('phoneNumber')?.touched)">Owner's
                Phone number is required</mat-error>

              <mat-error></mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-8 col-xs-12">
          <div *ngIf="addressType == '1'" class="row">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Owners Street Address</mat-label>
              <input matInput class="form-outline form-control" placeholder="Owners Street Address"
                formControlName="ownerStreetAddress" [matAutocomplete]="auto" />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description"
                  (onSelectionChange)="selectPlace(suggestion)">
                  {{ suggestion.description }}
                </mat-option>
              </mat-autocomplete>
              <mat-error>Owners Street Address is required</mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="addressType == '2'" class="row">
            <mat-form-field appearance="outline">
              <mat-label>Addressee's Full Legal name</mat-label>
              <input class="form-outline form-control" formControlName="addressName" matInput
                placeholder="Addressee's Full Legal name" />

              <mat-error>Addressee's Full Legal name is required</mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="addressType == '1'" class="row">
            <mat-form-field appearance="outline">
              <mat-label>Apt/Unit/Suite</mat-label>
              <input matInput formControlName="aptUnitSuite" placeholder="Apt/Unit/Suite" />
            </mat-form-field>
          </div>
          <div *ngIf="addressType == '2'" class="row">
            <mat-form-field appearance="outline">
              <mat-label>Street address or post office box number</mat-label>
              <input formControlName="addressOrPoBox" class="form-outline form-control" matInput
                placeholder="Street address or post office box number" />

              <mat-error>Street address or post office box number is required</mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="addressType == '1'" class="row gap-10">
            <div class="col">
              <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label>City</mat-label>
                <input matInput formControlName="city" placeholder="City" />
                <mat-error>City is required</mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label>State</mat-label>

                <mat-select formControlName="state" placeholder="State">
                  @for (state of states; track state) {
                  <mat-option [value]="state.id.toString()">{{
                    state.name
                    }}</mat-option>
                  }
                </mat-select>

                <mat-error>State is required</mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label>Zip Code</mat-label>
                <input matInput formControlName="zipCode" laceholder="Zip Code" />
                <mat-error
                  *ngIf="this.ownerForm.get('zipCode')?.errors?.['pattern'] && (ownerForm.get('zipCode')?.touched)">Zip
                  Code is invalid</mat-error>

                <mat-error
                  *ngIf="this.ownerForm.get('zipCode')?.errors?.['required'] && (ownerForm.get('zipCode')?.touched)">Zip
                  Code is required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="addressType == '2'" class="row">
            <mat-form-field appearance="outline">
              <mat-label>City, State, Province and Postal Code</mat-label>
              <input class="form-outline form-control" formControlName="cityStateProvince" matInput
                placeholder="City, State, Province and Postal Code" />

              <mat-error>City, State, Province and Postal Code is required</mat-error>
            </mat-form-field>
          </div>
          <div class="row" style="min-height: 56px">
            <mat-form-field appearance="outline" *ngIf="addressType == '2'">
              <mat-label>Country</mat-label>

              <mat-select formControlName="country" placeholder="Country">
                @for (state of country; track state) {
                <mat-option [value]="state.id">{{ state.name }}</mat-option>
                }
              </mat-select>
              <mat-error>Country is required</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="note" placeholder="Notes"></textarea>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="stepper.selectedIndex == 1" class="col-md-9 col-lg-10  col-xs-12">
    <div>
      <div class="row gap-20 flex-direction-xs-col">
        <div class="col">
          <app-rental-property #rentalPropertyComponent [rentalProperty]="this.propertyBasicInfo"
            [isIndividualPropertyOwner]="true" [isMotelHotel]="false" [states]="this.states"></app-rental-property>
        </div>
        <div class="col">
          <mat-card style="width: 100%" appearance="outlined">
            <mat-card-content>
              <div class="form-row span-row" style="padding-bottom: 1rem">
                <div class="form-col span-2">
                  <div class="Label" style="
                      color: rgba(0, 0, 0, 0.87);
                      font-size: 16px;
                      font-family: Roboto;
                      font-weight: 400;
                      line-height: 24px;
                      letter-spacing: 0.15px;
                      word-wrap: break-word;
                    ">
                    In case this property has more than 1 owner, add here
                  </div>
                </div>
                <div class="form-col">
                  <button (click)="addNewPropertyOwner()" 
                          [disabled]="dataSource.data.length >= 3"
                          mat-stroked-button 
                          mat-button 
                          class="button-stepper-back">
                    <mat-icon>add</mat-icon>
                    ADD
                  </button>
                  <div *ngIf="dataSource.data.length >= 3" style="
                      color: #f44336;
                      font-size: 12px;
                      margin-top: 4px;
                      font-family: Roboto;
                    ">
                    Maximum of 3 additional owners allowed
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-col">
                  <table mat-table [dataSource]="dataSource">
                    <!-- ID Column -->
                    <ng-container matColumnDef="firstName">
                      <th style="background-color: #e3e3e3; color: #000000" mat-header-cell *matHeaderCellDef>
                        First name
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.firstName }}
                      </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="lastName">
                      <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                        Last name
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.lastName }}
                      </td>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                      <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                        Email address
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.email }}
                      </td>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="phoneNumber">
                      <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                        Phone number
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.phoneNumber }}
                      </td>
                    </ng-container>
                    <!-- Email Column -->
                    <ng-container matColumnDef="action">
                      <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                        Actions
                      </th>
                      <td mat-cell *matCellDef="let element; let i = index">
                        <mat-icon style="color: #2196f3" class="icon-pointer" (click)="editOwner(element)" aria-label="Edit">edit</mat-icon>
                        <mat-icon (click)="removeOwner(i)" class="icon-pointer" style="color: red" aria-label="Delete">delete</mat-icon>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </table>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
    <div></div>
  </div>
  <div *ngIf="stepper.selectedIndex == 2" class="col-md-7 col-xs-12">
    <div class="form-containerReporting">
      <div class="form-row">
        <div class="form-col">
          <mat-label class="title-label">Who has the Reporting responsibility for this property ?
          </mat-label>
        </div>
      </div>
      <div class="form-row">
        <div class="form-col">
          <section class="example-section">
            <mat-checkbox class="primary" [(ngModel)]="isOwner" class="example-margin">Owner</mat-checkbox>
            <mat-checkbox class="primary" (change)="showManager($event)" [(ngModel)]="isManager" class="example-margin">Property
              Management Company</mat-checkbox>
          </section>
        </div>
      </div>
      <div class="form-row">
        <div class="form-col">
          <div *ngIf="isManager" style="max-height: 400px; overflow-y: scroll" class="row">
            <div class="Frame106" style="
                width: 100%;
                height: 100%;
                border-radius: 8px;
                border: 1px #e0e0e0 solid;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                gap: 24px;
                display: inline-flex;
              ">
              <div class="row" style="
                  align-self: stretch;
                  height: 56px;
                  padding-left: 16px;
                  padding-right: 16px;
                  justify-content: flex-end;
                  align-items: flex-end;
                  gap: 8px;
                  display: inline-flex;
                ">
                <div class="Frame152" style="
                    flex: 1 1 0;
                    flex-direction: column;
                    justify-content: flex-end;
                    align-items: flex-start;
                    gap: 8px;
                    display: inline-flex;
                  ">
                  <div class="Formlabel" style="
                      flex-direction: column;
                      justify-content: flex-start;
                      align-items: flex-start;
                      display: flex;
                    ">
                    <div class="Label" style="
                        color: rgba(0, 0, 0, 0.87);
                        font-size: 16px;
                        font-family: Roboto;
                        font-weight: 400;
                        line-height: 24px;
                        letter-spacing: 0.15px;
                        word-wrap: break-word;
                      ">
                      Add the property management companies here
                    </div>
                  </div>
                </div>

                <button (click)="addCompany()" mat-stroked-button mat-button class="button-stepper-back">
                  ADD COMPANY
                  <mat-icon>add</mat-icon>
                </button>
              </div>
              <div class="Frame162149" style="
                  align-self: stretch;
                  height: 128px;
                  flex-direction: column;
                  justify-content: flex-start;
                  align-items: flex-start;
                  display: flex;
                ">
                <table mat-table [dataSource]="companyDataSource">
                  <!-- ID Column -->
                  <ng-container matColumnDef="name">
                    <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                      Company name
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.companyName }}
                    </td>
                  </ng-container>

                  <!-- Name Column -->
                  <ng-container matColumnDef="streetAddress">
                    <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                      Street Address
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.streetAddress }}
                    </td>
                  </ng-container>

                  <!-- Email Column -->
                  <ng-container matColumnDef="aptUnitSuite">
                    <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                      Apt/unit/suite
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.aptUnitSuite }}
                    </td>
                  </ng-container>

                  <!-- Email Column -->
                  <ng-container matColumnDef="city">
                    <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                      City
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.city }}
                    </td>
                  </ng-container>
                  <!-- Email Column -->
                  <ng-container matColumnDef="state">
                    <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                      State
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.stateName }}
                    </td>
                  </ng-container>
                  <!-- Email Column -->
                  <ng-container matColumnDef="zipCode">
                    <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                      Zip Code
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.zipCode }}
                    </td>
                  </ng-container>
                  <!-- Email Column -->
                  <ng-container matColumnDef="action">
                    <th style="background-color: #e3e3e3" mat-header-cell *matHeaderCellDef>
                      Actions
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      <mat-icon class="icon-pointer" style="color: #2196f3" (click)="editCompany(element)" aria-label="Edit">edit</mat-icon>
                      <mat-icon (click)="removeCompany(i)" style="color: red" class="icon-pointer" aria-label="Delete">delete</mat-icon>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="managementcompaniesColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: managementcompaniesColumns"></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <app-rental-property-reporting-form [rentalPropertyReporting]="this.rentalPropertyReporting"
          #rentalPropertyReportingFormComponent [states]="this.states"></app-rental-property-reporting-form>
      </div>
    </div>
  </div>
  <div *ngIf="stepper.selectedIndex == 3" class="col-md-8 col-xs-12">
    <app-rental-property-license [rentalPropertyLicense]="this.rentalPropertyLicense"
      #rentalPropertyLicenseComponent></app-rental-property-license>
  </div>
  <div *ngIf="stepper.selectedIndex == 4 && !stepCompleted" class="col-md-7 col-xs-12">
    <app-agreements [agreements]="this.agreements"></app-agreements>
  </div>
  <div *ngIf="stepper.selectedIndex == 4 && stepCompleted" class="col-md-8 col-xs-12">
    <app-step-complete></app-step-complete>
  </div>
</div>
<div *ngIf="!stepCompleted" style="width: 100%; background-color: white">
  <div class="button-stepper-footer">
    <button (click)="openDialog()" mat-stroked-button mat-button class="button-stepper-cancel">
      CANCEL<mat-icon>close</mat-icon>
    </button>
    <button (click)="returnToStart()" *ngIf="stepper.selectedIndex === 0" mat-stroked-button mat-button
      class="button-stepper-back">
      BACK
      <mat-icon>arrow_left_alt</mat-icon>
    </button>
    <button (click)="goBack(stepper)" *ngIf="stepper.selectedIndex > 0" mat-stroked-button mat-button
      class="button-stepper-back">
      BACK
      <mat-icon>arrow_left_alt</mat-icon>
    </button>
    <button [disabled]="!ownerForm.valid" [ngClass]="{
        'button-stepper-allow': ownerForm.valid,
        'button-stepper': ownerForm.invalid
      }" *ngIf="stepper.selectedIndex == 0" mat-stroked-button mat-button (click)="goForward(stepper)"
      class="button-stepper-allow">
      NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
    </button>
    <button [disabled]="!propertyBasicInfo.valid" [ngClass]="{
        'button-stepper-allow': propertyBasicInfo.valid,
        'button-stepper': propertyBasicInfo.invalid
      }" *ngIf="stepper.selectedIndex == 1" mat-stroked-button mat-button (click)="goForward(stepper)"
      class="button-stepper-allow">
      NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
    </button>
    <button [disabled]="!rentalPropertyReporting.valid || (!isOwner && !isManager)" [ngClass]="{
        'button-stepper-allow':
          rentalPropertyReporting.valid && (isOwner || isManager),
        'button-stepper':
          rentalPropertyReporting.invalid || (!isOwner && !isManager)
      }" *ngIf="stepper.selectedIndex == 2" mat-stroked-button mat-button (click)="goForward(stepper)"
      class="button-stepper-allow">
      NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
    </button>
    <button [disabled]="!rentalPropertyLicense.valid" [ngClass]="{
        'button-stepper-allow': rentalPropertyLicense.valid,
        'button-stepper': rentalPropertyLicense.invalid
      }" *ngIf="stepper.selectedIndex == 3" mat-stroked-button mat-button (click)="goForward(stepper)"
      class="button-stepper-allow">
      NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
    </button>
    <button [disabled]="!agreements.valid" [ngClass]="{
        'button-stepper-allow': agreements.valid,
        'button-stepper': agreements.invalid
      }" *ngIf="stepper.selectedIndex == 4" mat-stroked-button mat-button (click)="save()"
      class="button-stepper-allow">
      SUBMIT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
    </button>
  </div>
</div>